import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const pixelfed = defineConnector({
  identifier: "pixelfed",
  name: "Pixelfed",
  tagLine: "Decentralized photo sharing platform",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Get your Pixelfed access token",
      items: [
        {
          kind: "markdown",
          content:
            "In your Pixelfed instance, go to **Settings → Applications**, create a new application, and obtain an access token via the OAuth flow.",
        },
      ],
    },
    {
      title: "Enter your details",
      items: [
        {
          kind: "url",
          label: "Instance URL",
          required: true,
          placeholder: "https://pixelfed.social",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Pixelfed instance.",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl}/api/v1/accounts/verify_credentials`,
  },
});
